/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M12.7502 1.5002h2.25c.0005 0-.0004 0 0 0 .4136-.0008.75-.3363.75-.75a.7502.7502 0 0 0-.6151-.738l-.1349-.012h-6c-.0004 0 .0005 0 0 0-.4135.0007-.75.3362-.75.75 0 .3681.2654.6744.6152.7379l.1349.012h2.2499v19.6287L3.578 13.4566l-.0474-.0474c-.0004-.0004.0003.0003 0 0a.7517.7517 0 0 0-.9568-.0868l-.1039.0868a.7502.7502 0 0 0-.0868.9568l.0868.1038 9.5303 9.5304 9.5304-9.5304c.0003-.0003-.0004.0004 0 0 .2919-.293.2925-.7681 0-1.0606a.7502.7502 0 0 0-.9568-.0868l-.1039.0868c-.0002.0002.0002-.0002 0 0l-7.7197 7.7198V1.5002Z"
    clipRule="evenodd"
  />,
  'Demote'
);
